export default "__VITE_ASSET__tAP5F$PU__"